import { ExpandableContent } from '@doveit/lego';
import React from 'react';
import * as styles from './DescriptionSection.style';

export interface DescriptionSectionProps {
  abstract: string,
  description: string,
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
  abstract,
  description,
}) => (
  <article>
    <p>
      {abstract}
    </p>

    <div css={styles.descriptionStyle}>
      <ExpandableContent
        openLabel="Leggi la descrizione completa"
        closeLabel="Nascondi la descrizione completa"
      >
        <p dangerouslySetInnerHTML={{ __html: description }} />
      </ExpandableContent>
    </div>
  </article>
);

export default DescriptionSection;
